import RoutesGrid from '../components/Grid';
import { RouteProvider } from '../store';

export default function RoutesGridLayout() {
  return <RouteProvider>
    <RoutesGrid />
  </RouteProvider>;
}
